import React from 'react';
import CustomNotification from './CustomNotification';

const NotificationContainer = ({ notifications, onRemove }) => {
  return (
    <div style={{ position: 'fixed', zIndex: 9999 }}>
      {notifications.map((notification, index) => (
        <div
          key={notification.id}
          style={{
            position: 'fixed',
            bottom: `${24 + (index * 80)}px`,
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 9999 + index
          }}
        >
          <CustomNotification
            message={notification.message}
            type={notification.type}
            duration={notification.duration}
            onClose={() => onRemove(notification.id)}
          />
        </div>
      ))}
    </div>
  );
};

export default NotificationContainer;



// WEBPACK FOOTER //
// ./src/components/NotificationContainer.js